import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Lock } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-950" data-id="element-145">
      {/* Green top accent line */}
      <div className="max-w-2xl mx-auto" data-id="element-146">
        <div className="w-full h-1 bg-green-500 rounded-full mb-8" data-id="element-147" />
      </div>

      <div className="max-w-2xl mx-auto" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 md:p-10 text-center" data-id="element-150">
            <Lock className="w-9 h-9 text-amber-500 mx-auto mb-4" strokeWidth={2} data-id="element-151" />

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3 leading-tight" data-id="element-152">
              🔒 GARANTÍA 7 DÍAS
            </h2>

            <p className="text-lg text-white font-medium mb-4" data-id="element-153">
              Devolución del 100%, sin preguntas ni formularios.
            </p>

            <p className="text-amber-500 font-bold italic" data-id="element-154">
              El riesgo es nuestro. La mejora es tuya.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}